import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import Button from '../../../../Button'
import { Chatroom } from '../../../../Chatroom'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { QA_NAME_REQUEST_PROFILE_TAB_RATING_COMMENTS } from '../../RequestProfileTabRating.constants'

import * as styles from './RequestProfileTabRatingCardComments.module.css'

import CommentsIcon from '../../../../../icons/comment-2.svg'

function RequestProfileTabRatingCardComments({ value = EMPTY_OBJECT }) {
  const { t } = useTranslation()

  const { handleLoadCounters, requestData } = useRequestProfileContext()

  const [isOpen, setIsOpen] = useState(false)
  const [chatUuid, setChatUuid] = useState(value.chat_uuid)
  const [commentsCount, setCommentsCount] = useState(
    value.counters?.comments || 0
  )

  // Rating cards are keyed by feedback uuid, so this instance is reused when
  // the list reloads with fresh data. Re-sync the derived state from the latest
  // `value` (local optimistic increments persist until the next reload).
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setChatUuid(value.chat_uuid)
    setCommentsCount(value.counters?.comments || 0)
  }, [value])

  function handleToggle() {
    setIsOpen(prev => !prev)
  }

  function handleChatroomCreated(data) {
    setChatUuid(data?.uuid)
    setCommentsCount(count => count + 1)
    handleLoadCounters?.()
  }

  function handleMessageSent() {
    setCommentsCount(count => count + 1)
    handleLoadCounters?.()
  }

  const requestPermissions = {
    ...requestData?.permissions,
    can_send_chat_message: value.permissions?.can_add_comment,
  }

  return (
    <>
      <div className={styles.footer}>
        <Button.Text
          isGrey
          beforeIconProps={{ Icon: CommentsIcon }}
          className={styles.commentsButton}
          isActive={isOpen}
          qaName={QA_NAME_REQUEST_PROFILE_TAB_RATING_COMMENTS}
          text={t('RequestProfileTabRating.CommentsActionKey', {
            count: commentsCount,
          })}
          tooltip={t(
            isOpen
              ? 'RequestProfileTabRating.CloseCommentsTooltipKey'
              : 'RequestProfileTabRating.OpenCommentsTooltipKey'
          )}
          onClick={handleToggle}
        />
      </div>
      {isOpen ? (
        <div className={styles.comments}>
          <Chatroom
            compact
            isPublic
            EmptyState={null}
            Header={null}
            createChatroomParams={{ feedback: value.uuid }}
            key={chatUuid}
            requestPermissions={requestPermissions}
            uuid={chatUuid}
            visibleToDwellers={requestData?.visibleToDwellers}
            onChatroomCreated={handleChatroomCreated}
            onMessageSent={handleMessageSent}
          />
        </div>
      ) : null}
    </>
  )
}

export default RequestProfileTabRatingCardComments
